import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { MomentModule } from 'ngx-moment';

import { AuthModule } from '®shared/auth';
import { ListStatusPanelModule } from '®shared/reading-list/list-status-panel';
import { ReadingListModule } from '®shared/reading-list/models';
import { UriModule } from '®shared/url-utils';

import { EditMenuComponent } from './edit-menu.component';
import { ListDetailsComponent } from './list-details.component';
import { ListLicenseComponent } from './list-license.component';

@NgModule({
  imports: [
    AuthModule,
    BsDropdownModule,
    CommonModule,
    MomentModule,
    ReadingListModule,
    RouterModule,
    ListStatusPanelModule,
    UriModule,
  ],
  declarations: [EditMenuComponent, ListDetailsComponent, ListLicenseComponent],
  exports: [EditMenuComponent, ListDetailsComponent, ListLicenseComponent],
})
export class ListDetailsModule {}
